import { render, staticRenderFns } from "./VersionExpired.vue?vue&type=template&id=5cba855a&"
import script from "./VersionExpired.vue?vue&type=script&lang=js&"
export * from "./VersionExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports